import type { BaseError as ViemBaseError } from "viem"
import { UserRejectedRequestError as EvmUserRejectedRequestError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"
import { walk } from "./walk"
/**
 * Using custom method for detecting since viem does not catch this for all wallets
 */
export function isUserRejectedRequestError(
  error: WagmiBaseError | ViemBaseError,
): boolean {
  return !!walk(error, e => {
    if (e instanceof EvmUserRejectedRequestError) {
      return true // Viem has detected this as a user rejected error
    }

    const errorMessage = e instanceof Error ? e.message : JSON.stringify(e)

    if (USER_REJECTED_REGEX.test(errorMessage)) {
      return true
    }

    return false
  })
}

export const USER_REJECTED_REGEX = /reject|denied|cancelled|canceled/i
